import type { RouteObject } from 'react-router-dom'

import type { NavItem } from '@/app/registry'

import { ProfilePage } from './ProfilePage'

export const routes: RouteObject[] = [{ path: '/settings/profile', element: <ProfilePage /> }]

export const nav: NavItem[] = [
  { path: '/settings/profile', label: 'Профиль', icon: 'user', mobile: null, order: 0, parent: '/settings' },
]
